import type {
  ChatPrompt,
  ChatPromptScope,
  CreateChatPromptRequest,
  UpdateChatPromptRequest,
} from "@repo/shared/types";
import { del, get, patch, post } from "./_client";

const BASE = "/internal/ai/chat-prompts";

export function listChatPrompts(scope: ChatPromptScope): Promise<ChatPrompt[]> {
  return get<ChatPrompt[]>(`${BASE}?scope=${encodeURIComponent(scope)}`);
}

export function createChatPrompt(data: CreateChatPromptRequest): Promise<ChatPrompt> {
  return post<ChatPrompt>(BASE, data satisfies CreateChatPromptRequest);
}

export function updateChatPrompt(id: string, data: UpdateChatPromptRequest): Promise<ChatPrompt> {
  return patch<ChatPrompt>(`${BASE}/${id}`, data satisfies UpdateChatPromptRequest);
}

export function deleteChatPrompt(id: string): Promise<{ success: boolean }> {
  return del<{ success: boolean }>(`${BASE}/${id}`);
}
